import Link from "next/link";
import { useState } from "react";
import Tabs from "./ui/Tabs";
import LoginBox from "./LoginBox";
import Button from "./ui/button";
import Space from "./ui/Space";
import { En, Fa } from "./ui/multilang";
import { useRouter } from "next/router";
import { sendGTMEvent } from "@next/third-parties/google";
import SignupWizard from "./signup-components/SignpWizard";

export default function LoginOrSignUpBox() {
  const { locale } = useRouter();
  const [tabVelue, setTabValue] = useState<"login" | "signup">("signup");
  return (
    <div className=" b-solid rd-lg w-full ">
      <div className="">
        <Tabs value={tabVelue} onValueChange={(v: "login" | "signup") => setTabValue(v)}>
          <Tabs.TabsList className="flex gap-1.5 pb-2 b-b-1 b-sand5">
            <Tabs.Trigger value="signup">
              <En>Sign Up</En>
              <Fa>ایجاد حساب کاربری</Fa>
            </Tabs.Trigger>
            <Tabs.Trigger
              value="login"
              className="login-tab-button h-2.75em px-1em
              rd-0.5em  fw-500 cursor-pointer appearance-none underline-none text-center whitespace-nowrap leading-1em
              focus-visible:outline-prm11
              focus:outline-prm9
              focus:outline-offset-3
              focus:outline-1.5
              b-transparent
              data-[state=active]:b-sand7
              hover:bg-sand4
              data-[state=active]:bg-sandA-4"
              onClick={() => sendGTMEvent({ event: "login-tab-click" })}
            >
              <En>Login</En>
              <Fa>ورود</Fa>
            </Tabs.Trigger>
          </Tabs.TabsList>
          <Space size="h-6" />
          <Tabs.Content value="signup">
            <SignupWizard />
            <p className="mt-8 text-sm text-center font-semibold">
              {locale === "en" ? "Already a user? " : "قبلاً با درسون کلاس داشته‌اید؟ "}
              <Button
                className="underline login-tab-button"
                variation="text"
                noPreStyle
                onClick={() => {
                  setTabValue("login");
                  sendGTMEvent({ event: "login-olduser-click" });
                }}
              >
                {locale === "en" ? "Login here." : "از اینجا وارد شوید."}
              </Button>
            </p>
          </Tabs.Content>
          <Tabs.Content value="login">
            <LoginBox />
            <Space size="h-6" />
            <div>
              <p className=" fs-sm text-center font-semibold">
                {locale === "en" ? "Have you taken a class with Darsoon before? " : "قبلاً با درسون کلاس داشته‌اید؟ "}
                <Link className="underline" href="/request-reset-password">
                  {locale === "en" ? "Click to get your password." : "برای گرفتن رمز خود کلیک کنید."}
                </Link>
              </p>
              <p className=" fs-sm text-center font-semibold">
                {locale === "en" ? "No Account? " : "کاربر جدید؟ "}
                <Button variation="text" className="underline" noPreStyle onClick={() => setTabValue("signup")}>
                  {" "}
                  {locale === "en" ? "Sign Up here." : "اینجا حساب کاربری ایجاد کنید."}
                </Button>
              </p>
            </div>
          </Tabs.Content>
        </Tabs>
        <div></div>
      </div>
    </div>
  );
}
